// extracted by mini-css-extract-plugin
module.exports = {"aids":"aids","inner":"inner","aid":"aid","state-5":"state-5","svgIcon":"svgIcon"};